import { Component, OnInit } from '@angular/core';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService, RAFUnitOfWork } from 'src/app/core/core.module';
import { JobType } from 'src/app/core/data/entities';

@Component({
    selector: 'app-job-type-dialog',
    templateUrl: './job-type-dialog.component.html',
    styleUrls: ['./job-type-dialog.component.scss'],
    standalone: false
})
export class JobTypeDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    jobType: JobType;
    displayOrder: number;
    processing: boolean = false;

    constructor(public modalRef: BsModalRef, private uow: RAFUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        if (!this.jobType)
            this.jobType = this.uow.jobTypes.createEntity({
                displayOrder: this.displayOrder
            }) as JobType;
    }

    async save() {
        if (this.processing) return;
        this.processing = true;

        const success = this.validate();
        if (!success) {
            this.processing = false;
            return;
        }

        await this.uow.commit([this.jobType]);
        this.result.next({ success: true });
    }

    close() {
        if (this.processing) return;
        this.processing = true;
        this.jobType.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
